export class ActionField {
    name:string = "";
    value:string = "";
}
